import React from "react";
import ReactEchartsCore from "echarts-for-react/lib/core";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";

import "echarts/lib/chart/bar";

import NHFetch from "../../utils/NHFetch.js";

const yxxtBasicUrl = "api/zhxg-yxxt"; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 30 * 1000; //轮询时间间隔
const pageSize = 10; //分页显示每页数据数量

/**
 * 各学院报到统计面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-29
 * Version: 1.0
 * Modify log:
 */
export default class _BarBox1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各学院报到统计数据
            page: 0, //当前显示的页数
            activeBarData: [], //当前显示的数据
        };

        this.polling;
        this.activePolling;
    }

    componentDidMount() {
        this.getData();
    }

    // 组件卸载时清除定时器
    componentWillUnmount() {
        if (this.polling) {
            clearTimeout(this.polling);
        }
        if (this.activePolling) {
            clearInterval(this.activePolling);
        }
    }

    /**
     * * 获取各学院报到统计数据
     * @memberof _BarBox1
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + "/sstj/getRateOfCollegeReported", "GET")
            .then((res) => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    // let data = [
                    //     {pm: 1, xymc: "信息工程与商务管理学院", bdl: 0.1235},
                    //     {pm: 2, xymc: "文化旅游学院", bdl: 1},
                    //     {pm: 3, xymc: "应用法学与公共事业学院", bdl: 0.7844},
                    //     {pm: 4, xymc: "建筑与艺术设计学院", bdl: 0.6054},
                    //     {pm: 5, xymc: "财务金融学院", bdl: 0.5255},
                    //     {pm: 6, xymc: "外语外贸学院", bdl: 0.4316},
                    //     {pm: 7, xymc: "学前教育学院", bdl: 0.3},
                    // ];
                    let data = res.data;
                    let barData = [];
                    let pageItems = [];
                    // 报到率数据格式化（报到率保留三位小数，即在百分比的形式下保留一位小数）
                    let dataFormat = [];
                    for (let i of data) {
                        let obj = {};
                        obj.bdl = this.transformDecimal(i.bdl * 100, 1).toFixed(1);
                        obj.pm = i.pm;
                        obj.xymc = i.xymc;
                        dataFormat.push(obj)
                    }
                    data = dataFormat;

                    //如果数据量超过每页最大显示数量，则做分页显示处理
                    data.map((item, index) => {
                        pageItems.push(item);

                        if ((index + 1) % pageSize === 0 || index === data.length - 1) {
                            barData.push(pageItems);
                            pageItems = [];
                        }
                    });

                    this.setState(
                        {errCount: 0, barData: barData, activeBarData: barData[0]},
                        () => {
                            if (this.activePolling) {
                                clearInterval(this.activePolling);
                            }

                            //隔5秒换页
                            this.activePolling = setInterval(() => {
                                let {page, barData} = this.state;
                                const length = barData.length;

                                if (page + 1 >= length) {
                                    page = 0;
                                } else {
                                    page += 1;
                                }
                                let activeBarData = barData[page];

                                this.setState({page, activeBarData});
                            }, 5000);
                        }
                    );
                }
            })
            .catch((err) => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({errCount: errCount + 1});
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                    if (this.activePolling) {
                        clearInterval(this.activePolling);
                    }
                }
            });
    };

    /**
     * * 构造学院报到率条形统计图
     * @memberof _BarBox1
     */
    getBarOption = () => {
        const {rem} = this.props;
        const {activeBarData = []} = this.state;

        // 根据报到率进行排序
        activeBarData.sort(function (a, b) {
            return b.bdl - a.bdl;
        });

        // y轴系列（学院名称）
        let college = activeBarData.map((item) => {
            return item.xymc;
        });

        // 报到率百分比
        let bdl = activeBarData.map((item) => {
            return item.bdl;
        });

        const option = {
            title: {
                text: "各学院报到统计",
                textStyle: {
                    color: "#05ffe3",
                    fontSize: 0.18 * rem,
                    fontWeight: 100,
                },
            },
            grid: {
                top: "8%",
                left: '0%',
                //right: '10%',
                bottom: "3%",
                containLabel: true,
            },
            xAxis: {
                show: false,
            },
            yAxis: [
                {
                    show: true,
                    data: college,
                    inverse: true,
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize: 0.14 * rem,
                            color: '#FFFFFF'
                        },
                        rich: {
                            // lg: {
                            //     backgroundColor: '#74dafc',
                            //     color: '#18306F',
                            //     borderRadius: 0.18 * rem,
                            //     align: 'center',
                            //     width: 0.18 * rem,
                            //     height: 0.18 * rem
                            // },
                            title: {
                                color: "white",
                            },
                        },
                    },
                },
                {
                    show: true,
                    inverse: true,
                    data: bdl.map((item, index) => {
                        return item + "%";
                    }),
                    axisLabel: {
                        textStyle: {
                            fontSize: 0.14 * rem,
                            color: "#02ede2",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
            ],
            series: [
                {
                    name: "条",
                    type: "bar",
                    barMaxWidth: 0.14 * rem,
                    // barMinHeight: 1,
                    // barMinWidth:0.5,
                    yAxisIndex: 0,
                    data: bdl.map((item, index) => {
                        return item;
                    }),
                    silent: false,
                    barCategoryGap: "60%",
                    itemStyle: {
                        normal: {
                            barBorderRadius: 0.2 * rem,
                            color: {
                                type: "bar",
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#267ef8", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#02ede2", // 100% 处的颜色
                                    },
                                ],
                                globalCoord: false, // 缺省为 false
                            },
                        },
                    },
                },
                {
                    name: "框",
                    type: "bar",
                    barMaxWidth: 0.14 * rem,
                    barMinHeight: 1,
                    yAxisIndex: 1,
                    data: bdl.map((item, index) => {
                        return 100;
                    }),
                    silent: false,
                    barCategoryGap: "60%",
                    itemStyle: {
                        normal: {
                            barBorderRadius: 0.2 * rem,
                            borderColor: {
                                type: "bar",
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#267ef8", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#02ede2", // 100% 处的颜色
                                    },
                                ],
                                globalCoord: false, // 缺省为 false
                            },
                            borderWidth: 1,
                            color: "transparent",
                        },
                    },
                },
                // {
                //     //设置柱状图的外框
                //     name: "框",
                //     //设置为柱状
                //     type: "bar",
                //     barCategoryGap:50,
                //     //柱状图的宽度
                //     barWidth:0.14 * rem,
                //     //每一个的样式
                //     itemStyle:{
                //     //颜色
                //     color:"transparent",
                //     //边框色
                //     borderColor:"red",
                //     //border宽度
                //     borderWidth:'0.1',
                //     //border的边角弧度
                //     barBorderRadius:15
                //     },
                //     //柱状图的长度
                //     data: [100,100,100,100,100],
                //     //第二个堆在第一个上
                //     yAxisIndex:0,
                //     }
            ],
        };

        return option;
    };

    transformDecimal = (number, i) => {
        let decimalNum = null;
        // 先转换为数值型
        let num = Number(number);
        // 判断是否为数值型
        if (!isNaN(num)) {
            // 切分整数与小数
            let arr = num.toString().split(".");
            // 是小数且小数位大于保留个数
            if (arr.length > 1 && arr[1].length > i) {
                // 小数部分字符串
                let decimal = arr[1].slice(i, i + 1);
                // toFixed 有 bug，四舍六入五随机
                // 当四舍五入的数为 5，给其 + 1
                if (decimal === '5') {
                    // 这里可能会存在 0.1 ** 5 = 0.000010000000000000003 但不影响四舍五入
                    num += Math.pow(0.1, i + 1);
                }
                decimalNum = num.toFixed(i);
            } else {
                decimalNum = num;
            }
            decimalNum = Number(decimalNum);
        }
        return decimalNum;
    }

    render() {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <ReactEchartsCore
                    style={{width: "100%", height: "100%"}}
                    echarts={echarts}
                    option={this.getBarOption()}
                    notMerge={true}
                    lazyUpdate={true}
                />
                <div></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/Show-gdnh/_BarBox1.js